import React from 'react';

const Table = ({ columns, data, actions }) => {
  return (
    <div className="overflow-x-auto rounded shadow bg-white">
      <table className="min-w-full divide-y divide-slate-200">
        <thead className="bg-slate-50">
          <tr>
            {columns.map((col) => (
              <th key={col.key} className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">
                {col.title}
              </th>
            ))}
            {actions && <th className="px-4 py-3 text-xs font-semibold text-slate-600 uppercase">Actions</th>}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-slate-100">
          {data.map((row, idx) => (
            <tr key={idx}>
              {columns.map((col) => (
                <td key={col.key} className="px-4 py-2 whitespace-nowrap text-slate-700 text-sm">
                  {row[col.key]}
                </td>
              ))}
              {actions && (
                <td className="px-4 py-2 whitespace-nowrap flex gap-2">
                  {actions(row)}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
